/**
 * 截图工具函数
 * 提供页面截图功能
 */
import html2canvas from 'html2canvas'

/**
 * 截取整个页面或指定元素的截图
 * @param {HTMLElement|String} element - 要截图的DOM元素或CSS选择器，默认为document.body
 * @param {Object} options - html2canvas配置选项
 * @returns {Promise<Object>} - 返回包含截图数据的Promise
 */
export const captureScreenshot = async () => {
  console.log(2939293299)
  try {
    const targetElement = document.getElementsByClassName('ai-assistant__wrapper-active')[0]
    if (!targetElement) {
      throw new Error('截图目标元素不存在')
    }
    // 默认配置
    const defaultOptions = {
      allowTaint: true,
      useCORS: true,
      // 降低缩放比例以提高性能
      scale: 1.5,
      logging: false,
      // 减少渲染的元素数量
      ignoreElements: e => {
        // 过滤掉header-wrapper类名的元素
        if (e.classList.contains('header-wrapper')) {
          return true
        }
        // 保留目标元素及其包含的元素
        if (targetElement.contains(e) || e.contains(targetElement)) {
          return false
        }
        if (['HEADER', 'HEAD', 'STYLE', 'LINK'].includes(e.tagName)) {
          return false
        }
        return true
      },
      // 性能优化选项
      backgroundColor: null, // 不渲染背景可以提高性能
      imageTimeout: 0, // 不等待图片加载完成
      removeContainer: true, // 使用后移除临时容器
      foreignObjectRendering: false // 禁用foreignObject渲染
    }

    // 执行截图
    const canvas = await html2canvas(targetElement, defaultOptions)
    // 返回截图数据
    return {
      blob: await new Promise(resolve => {
        canvas.toBlob(blob => resolve(blob), 'image/jpeg', 0.8)
      })
    }
  } catch (error) {
    console.error('截图失败:', error)
    throw error
  }
}

export default {
  captureScreenshot
}
